<div class="ayarlar-container">

  <!-- HASSASIYET AYARLARI SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('hassasiyet')">
      <i class="icon" [class.chevron-down]="sekmeler.hassasiyet" [class.chevron-right]="!sekmeler.hassasiyet"></i>
      <span>Hassasiyet</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.hassasiyet">
      <div class="ayar-satiri">
        <label>Hassasiyet</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="hassasiyet" (change)="kaydetAyarlar()" step="0.01" min="0.01" class="ayar-input">
          <span class="ayar-birimi">mm</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Min. Ölçüm</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="minOlcum" (change)="kaydetAyarlar()" step="0.1" min="0" class="ayar-input">
          <span class="ayar-birimi">mm</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Max. Ölçüm</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="maxOlcum" (change)="kaydetAyarlar()" step="10" min="1" class="ayar-input">
          <span class="ayar-birimi">mm</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Çember Tol.</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="cemberTolerAnsi" (change)="kaydetAyarlar()" step="0.01" min="0.01" max="1" class="ayar-input">
          <span class="ayar-birimi">%</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Sapma Eşik</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="cemberSapmaEsigi" (change)="kaydetAyarlar()" step="1" min="1" max="100" class="ayar-input">
          <span class="ayar-birimi">%</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Parallel</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="parallelKontrol" (change)="kaydetAyarlar()" step="0.0001" min="0" class="ayar-input">
          <span class="ayar-birimi">°</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Yüzey Mes.</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="yuzeyMesafeTolerAnsi" (change)="kaydetAyarlar()" step="0.00001" min="0" class="ayar-input">
          <span class="ayar-birimi">mm</span>
        </div>
      </div>
    </div>
  </div>

  <!-- NOT: Görüntü ayarları artık "Fiko Three.js Ayarlar" → "Ölçüm Ayarları" sekmesinde yönetilmektedir -->

  <!-- ÖLÇÜM BİRİMLERİ SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('birimler')">
      <i class="icon" [class.chevron-down]="sekmeler.birimler" [class.chevron-right]="!sekmeler.birimler"></i>
      <span>Birimler</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.birimler">
      <div class="ayar-satiri">
        <label>Birim</label>
        <div class="birim-secim">
          <select [(ngModel)]="secilenBirim" (change)="kaydetAyarlar()" class="birim-select">
            <option value="mm">mm</option>
            <option value="cm">cm</option>
            <option value="m">m</option>
            <option value="inch">in</option>
          </select>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Ondalık</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="ondalikSayiBas" (change)="kaydetAyarlar()" min="0" max="4" step="1" class="ayar-input">
          <span class="ayar-birimi">ba.</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>cm Fakt.</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="ciBirimFaktore" (change)="kaydetAyarlar()" step="0.01" min="0" class="ayar-input">
        </div>
      </div>

      <div class="ayar-satiri">
        <label>inch Fakt.</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="inchFaktore" (change)="kaydetAyarlar()" step="0.00001" min="0" class="ayar-input">
        </div>
      </div>

      <div class="ayar-satiri">
        <label>m Fakt.</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="mFaktore" (change)="kaydetAyarlar()" step="0.0001" min="0" class="ayar-input">
        </div>
      </div>

      <div class="birim-yardimci">
        <p><strong>Dönüş:</strong> 100mm = {{ (birimDonustur(100, 'mm', 'cm') | number:'1.0-2') }}cm</p>
      </div>
    </div>
  </div>

  <!-- SEÇİM AYARLARI -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('secim')">
      <i class="icon" [class.chevron-down]="sekmeler.secim" [class.chevron-right]="!sekmeler.secim"></i>
      <span>Seçim</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.secim">
      <div class="ayar-satiri">
        <label>Seçim 1</label>
        <div class="birim-secim">
          <select [(ngModel)]="secim1Turu" (change)="kaydetAyarlar()" class="birim-select">
            <option *ngFor="let tur of secimTurleri" [value]="tur">{{ tur }}</option>
          </select>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Seçim 2</label>
        <div class="birim-secim">
          <select [(ngModel)]="secim2Turu" (change)="kaydetAyarlar()" class="birim-select">
            <option *ngFor="let tur of secimTurleri" [value]="tur">{{ tur }}</option>
          </select>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Kenar Yakalama Hassasiyeti</label>
        <div class="birim-secim" style="display:flex; align-items:center; gap:8px; flex:1;">
          <input type="range" min="8" max="80" step="1"
                 [(ngModel)]="kenarHassasiyet" (input)="kaydetAyarlar()" style="flex:1;">
          <span style="min-width:42px; text-align:right;">{{ kenarHassasiyet }} px</span>
        </div>
      </div>
      <div class="ayar-aciklama" style="font-size:11px; opacity:0.7; margin-top:-4px;">
        Yüksek değer → kenarlar daha kolay seçilir (imleç kenara uzakken bile yakalar).
      </div>

      <div class="ayar-satiri">
        <label>Klasik Uzatma Çizgisi (paralel)</label>
        <input type="checkbox" [(ngModel)]="klasikOlcumStili" (change)="kaydetAyarlar()">
      </div>
      <div class="ayar-aciklama" style="font-size:11px; opacity:0.7; margin-top:-4px;">
        Açık: sürüklemede uzatma çizgileri eski paralel haliyle kalır. Kapalı: çizgiler seçili yüzeylere değecek şekilde uzar.
      </div>

      <!-- NOT: Diğer Kenar/Nokta seçim ve Raycast ayarları "Fiko Three.js Ayarlar" → "Raycast" sekmesindedir -->
    </div>
  </div>

  <!-- GEÇMİŞ VE LİMİTLER -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('gecmis')">
      <i class="icon" [class.chevron-down]="sekmeler.gecmis" [class.chevron-right]="!sekmeler.gecmis"></i>
      <span>Geçmiş</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.gecmis">
      <div class="ayar-satiri">
        <label>Geçmiş Limiti</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="olcumGecmisiLimiti" (change)="kaydetAyarlar()" step="5" min="5" max="100" class="ayar-input">
          <span class="ayar-birimi">adedi</span>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Plane Boy.</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="planeGeometriBoyu" (change)="kaydetAyarlar()" step="100" min="100" max="5000" class="ayar-input">
          <span class="ayar-birimi">bir</span>
        </div>
      </div>
    </div>
  </div>

  <!-- v2.0.0 - GÖRSEL AYARLAR -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('gorsel')">
      <i class="icon" [class.chevron-down]="sekmeler.gorsel" [class.chevron-right]="!sekmeler.gorsel"></i>
      <span>Görsel Stiller</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.gorsel">
      <!-- PRESET SEÇİMİ -->
      <div class="ayar-satiri">
        <label>Stil Seti</label>
        <div class="birim-secim">
          <select [(ngModel)]="dimensionPreset" (change)="onPresetChange()" class="birim-select">
            <option *ngFor="let preset of presetListesi" [value]="preset.key">{{ preset.label }}</option>
          </select>
        </div>
      </div>

      <div class="ayar-bolum-baslik">Animasyon</div>

      <div class="ayar-satiri">
        <label>Animasyon</label>
        <div class="deger-grup">
          <input type="checkbox" [(ngModel)]="animasyonAktif" (change)="kaydetGorselAyarlar()">
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="animasyonAktif">
        <label>Süre</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="animasyonSuresi" (change)="kaydetGorselAyarlar()" step="50" min="50" max="1000" class="ayar-input">
          <span class="ayar-birimi">ms</span>
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="animasyonAktif">
        <label>Fade In</label>
        <div class="deger-grup">
          <input type="checkbox" [(ngModel)]="fadeInAktif" (change)="kaydetGorselAyarlar()">
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="animasyonAktif">
        <label>Fade Out</label>
        <div class="deger-grup">
          <input type="checkbox" [(ngModel)]="fadeOutAktif" (change)="kaydetGorselAyarlar()">
        </div>
      </div>

      <div class="ayar-bolum-baslik">Glow Efekti</div>

      <div class="ayar-satiri">
        <label>Glow</label>
        <div class="deger-grup">
          <input type="checkbox" [(ngModel)]="glowAktif" (change)="kaydetGorselAyarlar()">
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="glowAktif">
        <label>Yoğunluk</label>
        <div class="deger-grup">
          <input type="range" [(ngModel)]="glowYogunlugu" (change)="kaydetGorselAyarlar()" step="0.1" min="0" max="1" class="ayar-slider">
          <span class="ayar-birimi">{{ glowYogunlugu | number:'1.1-1' }}</span>
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="glowAktif">
        <label>Renk</label>
        <div class="deger-grup">
          <input type="color" [(ngModel)]="glowRengi" (change)="kaydetGorselAyarlar()" class="ayar-color">
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="glowAktif">
        <label>Hover'da</label>
        <div class="deger-grup">
          <input type="checkbox" [(ngModel)]="glowHoverAktif" (change)="kaydetGorselAyarlar()">
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="glowAktif">
        <label>Seçimde</label>
        <div class="deger-grup">
          <input type="checkbox" [(ngModel)]="glowSelectAktif" (change)="kaydetGorselAyarlar()">
        </div>
      </div>

      <div class="ayar-bolum-baslik">Tooltip</div>

      <div class="ayar-satiri">
        <label>Tooltip</label>
        <div class="deger-grup">
          <input type="checkbox" [(ngModel)]="tooltipAktif" (change)="kaydetGorselAyarlar()">
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="tooltipAktif">
        <label>Gecikme</label>
        <div class="deger-grup">
          <input type="number" [(ngModel)]="tooltipGecikme" (change)="kaydetGorselAyarlar()" step="50" min="0" max="1000" class="ayar-input">
          <span class="ayar-birimi">ms</span>
        </div>
      </div>

      <div class="ayar-bolum-baslik">Ok & Çizgi Stilleri</div>

      <div class="ayar-satiri">
        <label>Ok Stili</label>
        <div class="birim-secim">
          <select [(ngModel)]="okStili" (change)="kaydetGorselAyarlar()" class="birim-select">
            <option *ngFor="let stil of okStilleri" [value]="stil.key">{{ stil.label }}</option>
          </select>
        </div>
      </div>

      <div class="ayar-satiri">
        <label>Çizgi Stili</label>
        <div class="birim-secim">
          <select [(ngModel)]="cizgiStili" (change)="kaydetGorselAyarlar()" class="birim-select">
            <option *ngFor="let stil of cizgiStilleri" [value]="stil.key">{{ stil.label }}</option>
          </select>
        </div>
      </div>

      <!-- GÖRSEL AYARLAR BUTONLARI -->
      <div class="ayarlar-butonlari gorsel-butonlar">
        <button class="ui mini button primary" (click)="kaydetGorselAyarlar()" title="Görsel ayarları kaydet">
          <i class="icon save"></i>Kaydet
        </button>
        <button class="ui mini button" (click)="resetGorselAyarlar()" title="Varsayılana dön">
          <i class="icon refresh"></i>Sıfırla
        </button>
      </div>
    </div>
  </div>

  <!-- BUTONLAR -->
  <div class="ayarlar-butonlari">
    <button class="ui mini button" (click)="kaydetAyarlar()" title="Ayarları kaydet">
      <i class="icon save"></i>Kaydet
    </button>
    <button class="ui mini button" (click)="resetAyarlar()" title="Varsayılana dön">
      <i class="icon refresh"></i>Sıfırla
    </button>
  </div>

</div>
